"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalTabs = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const VerticalTabsBottom_1 = require("./VerticalTabsBottom");
const VerticalTabContext_1 = require("./VerticalTabContext");
const VerticalTabs = props => {
    const { children } = props;
    let bottom = null;
    let tabs = [];
    react_1.default.Children.forEach(children, (child) => {
        if (child && child.type === VerticalTabsBottom_1.VerticalTabsBottom) {
            bottom = child;
        }
        else {
            tabs.push(child);
        }
    });
    return ((0, jsx_runtime_1.jsx)(VerticalTabContext_1.VerticalTabContext.Provider, Object.assign({ value: props }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "vertical-tabs" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "vertical-tabs__top" }, { children: tabs }), void 0), bottom] }), void 0) }), void 0));
};
exports.VerticalTabs = VerticalTabs;
//# sourceMappingURL=VerticalTabs.js.map